import axios from 'axios';
import './styles.scss';
import _ from 'lodash';
import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import { GAME_URL } from '../../../redux/constants';
import Stack from '@mui/material/Stack';
import HearingIcon from '@material-ui/icons/Hearing';
import { Button, Dialog, DialogActions, DialogContent, IconButton, Tooltip, Typography } from '@material-ui/core';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import StoryText from "../../components/student/StoryText";
import reviewData from '../../../reviewData';
import { runAnalysis } from '../../../redux/actions/buddyBooks';
import { isWindowAvailable } from '../../../utils/utility';

let chunks = [];
var superBuffer;
let analysisOffsets;
let computerOffsets;
let textIndex = 0;
let skippedIndex = null;
let computerIndex = 0;
let storyWordList;
let currentIndex;
let currentAnalysis;
let toggleAutoRecording = false;
let holdReviewIndex = 0;
let silenceTimeDelay = null;
let reviewEnd = false;
let earIconPlayed = false;
let isEarIconRed = false;
let isReviewReloaded = false;
let reviewStory;
let paraSegments = [];
let totalParaAnalysis = [];

function ReviewPage({ dispatch, auth, savedSessionResponse, story, settings, fullStory }) {

    const recordRef = useRef(null);
    const [url, setUrl] = useState('');
    const [reviewIndex, setReviewIndex] = useState(0);
    // const [startTime, setStartTime] = useState(null);
    const [lastSpeakTime] = useState(null);
    const [isRecording, setIsRecording] = useState(false);
    const [paraSegmentsIndex, setParaSegmentsIndex] = useState(0);
    const [currentText, setCurrentText] = useState("");
    const [currentSegment, setCurrentSegment] = useState("");
    const [highlightWordIndex, setHighlightWordIndex] = useState(0);
    const [playUser, setPlayUser] = useState(false);
    const [playRecording] = useState(false);
    const [playHumanVoice, setPlayHumanVoice] = useState(false);
    const [playComputerVoice, setPlayComputerVoice] = useState(false);
    const [audioError,setAudioError] = useState(false)

    let history = useHistory();

    let sessionData = savedSessionResponse && savedSessionResponse.data;

    if (_.isEmpty(story)) {
        let bookStory = localStorage.getItem('book_story');
        bookStory = bookStory && JSON.parse(bookStory);
        if (!_.isEmpty(bookStory)) {
            reviewStory = bookStory;
        } else {
            if (sessionData) {
                history.push(`/story/${sessionData.bookId}`)
            }
        }
    } else {
        reviewStory = story;
    }

    const playSegmentHuman = (speechId) => {
        const url = `${GAME_URL}/buddy-books/save/${speechId}/file`;
        const config = {
            responseType: 'blob',
            headers: {
                'access-token': `${auth?.token}`
            }
        };
        axios.get(url, config).then((response) => {
            setUrl(URL.createObjectURL(response.data));
            setPlayUser(true);
            setPlayHumanVoice(true);
        })
    }

    const playSegment = async (text) => {
        const url = `${GAME_URL}/tts`;
        var data = { text }
        const config = {
            responseType: 'blob',
            headers: {
                'access-token': `${auth?.token}`
            }
        };
        var response = await axios.post(url, data, config);
        console.log("c-h play", response.data.size);
        if (response.data.size) {
            setUrl(URL.createObjectURL(response.data));
            setPlayUser(true);
        } else {
            setReviewIndex(reviewIndex + 1);
        }
    }

    const onSubmitReview = (blob) => {
        let indexes = sessionData && JSON.parse(sessionData.indexes);
        let newReviewData = reviewData && reviewData[holdReviewIndex];
        let recordingIndex = newReviewData && parseInt(indexes[newReviewData.analysisIndex]);
        let savedUser = localStorage.getItem("logged_user");
        const person = savedUser && JSON.parse(savedUser);
        const url = `${GAME_URL}/speech/${person.info?.personId}/upload`;
        console.log("onSubmitReview text ", currentText);
        var data = { "possibleCorrect": [currentText], "possibleIncorrect": [] }
        var id = sessionData && sessionData.bookId;
        const config = {
            headers: {
                'access-token': `${auth?.token}`
            }
        };

        axios.post(url, data, config)
            .then((response) => {
                var speechId = response.data.id;
                let dtos = sessionData && sessionData.reviewPassageDtos;
                let analysisIndex = newReviewData.analysisIndex;
                let scoreId = dtos && dtos[analysisIndex].scoreId;
                dispatch(runAnalysis(speechId, id, blob, recordingIndex, superBuffer, scoreId));
                if (analysisIndex === (indexes.length - 1)) {
                    playSegment(reviewData[18].text);
                    reviewEnd = true;
                } else {
                    setReviewIndex(holdReviewIndex + 1);
                }
            });
    };

    const onStopReview = () => {
        const blob = new Blob(chunks.slice(-1), { 'type': 'audio/webm;codecs=opus' });
        chunks = [];
        onSubmitReview(blob);
    };

    const handleKeyDown = (e) => {
        let code = e.keyCode;
        //Enter key submits recording
        if (code === 13) {
            e.preventDefault();
            console.log("enter pressed");
            recordRef && recordRef.current && recordRef.current.click();
        };
    }

    useEffect(() => {
        playSegment(reviewData[reviewIndex].text);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            reviewEnd = false;
            storyWordList = '';
        };
    }, []);

    useEffect(() => {
        if (isWindowAvailable() && window.objMd && window.objMd.mediaRecorder && isRecording) {
            window.objMd.mediaRecorder.onstop = onStopReview;
            window.objMd.mediaRecorder.ondataavailable = function (e) {
                chunks.push(e.data);
                superBuffer = new Blob(chunks.slice(-1));
                superBuffer = window.URL.createObjectURL(superBuffer);
            }
        }
    }, [isRecording]);

    useEffect(() => {
        let reviewType = reviewData && reviewData[reviewIndex] && reviewData[reviewIndex].type;
        let analysisIndex = reviewData[reviewIndex].analysisIndex;
        switch (reviewType) {
            case 'Computer':
                computerIndex = 0;
                playSegment(reviewData[reviewIndex].text);
                break;
            case 'Computer-Human':
                let indexes = sessionData && JSON.parse(sessionData.indexes);
                let currentGroup = parseInt(indexes[analysisIndex]);
                let storySegmentDto = reviewStory.storySegmentDto;
                let storySegment;
                let text = '';
                let indexFound = false;

                if (paraSegmentsIndex === 0) {
                    if (_.isEmpty(paraSegments) && !_.isEmpty(fullStory)) {
                        fullStory.storySegmentDto.forEach(item => {
                            if (item.groupNumber === currentGroup) {
                                text += ' ' + item.text;
                                paraSegments.push(item);
                                if (!indexFound) {
                                    currentIndex = item.section;
                                    indexFound = true;
                                }
                            }
                        })
                    } else {
                        storySegmentDto.forEach(item => {
                            if (item.groupNumber === currentGroup) {
                                text += ' ' + item.text;
                                paraSegments.push(item);
                                if (!indexFound) {
                                    currentIndex = item.section;
                                    indexFound = true;
                                }
                            }
                        })
                    }
                }
                if (!_.isEmpty(paraSegments)) {
                    setPlayComputerVoice(true);
                    storySegment = paraSegments[paraSegmentsIndex];
                    let computerAnalysis = !_.isEmpty(storySegment) && JSON.parse(storySegment.timing);
                    totalParaAnalysis.push(...computerAnalysis);
                    text = storySegment.text;
                    if (totalParaAnalysis.length > 0 && !playUser) {
                        computerOffsets = totalParaAnalysis.map((value) => {
                            return value.offset;
                        });
                    };
                    playSegment(text);
                }
                setCurrentText(currentText+" "+text);
                break;
            case 'RecordedMedia':
                let speechIds = sessionData && JSON.parse(sessionData.speechIds);
                playSegmentHuman(speechIds[analysisIndex]);
                break;

            default:
                break;
        }

        if (reviewIndex + 1 >= reviewData.length) {
            localStorage.setItem('review_done', "true");
            // dispatch(getStory(sessionData.bookId));
            history.push(`/story/${sessionData.bookId}`);
        }
    }, [reviewIndex, paraSegmentsIndex])

    useEffect(() => {
        if (performance.navigation.type === 1 && !isReviewReloaded) {
            console.info("This page is reloaded");
            isReviewReloaded = true;
            let cs = localStorage.getItem("current_section");
            let bookId = localStorage.getItem("book_id");
            bookId = cs && JSON.parse(cs).id;
            history.push(`story/${bookId}`);
        }
        if (savedSessionResponse.data) {
            if (currentAnalysis && currentAnalysis.NBest && !playRecording) {
                analysisOffsets = currentAnalysis.NBest[0].Words.map((value) => {
                    return value.Offset;
                });
            };
        }
    }, [savedSessionResponse.data, reviewIndex])

    const handleAudioEnd = () => {
        setPlayUser(false);
        isEarIconRed = false;
        let reviewType = reviewData && reviewData[reviewIndex] && reviewData[reviewIndex].type;

        if (reviewType === 'Computer-Human' && paraSegmentsIndex + 1 < paraSegments.length) {
            setParaSegmentsIndex(paraSegmentsIndex + 1);
            setHighlightWordIndex(computerOffsets.length);
            if (playComputerVoice) {
                setPlayComputerVoice(false);
                setPlayHumanVoice(false);
                computerIndex = computerIndex + 1;
            }
        } else {
            setParaSegmentsIndex(0);
            totalParaAnalysis = [];
            paraSegments = [];

            if (reviewEnd || (reviewIndex + 1 >= reviewData.length)) {
                localStorage.setItem(`review_done`, "true");
                history.push("/story/" + savedSessionResponse?.data?.bookId);
            } else {
                if (!earIconPlayed) {
                    setReviewIndex(reviewIndex + 1);
                }
            }
            if (playHumanVoice || playComputerVoice) {
                setPlayComputerVoice(false);
                setPlayHumanVoice(false);
                setHighlightWordIndex(0);
                textIndex = 0;
                computerIndex = 0;
            }
        }

    }

    const handleEarIcon = (text) => {
        isEarIconRed = true;
        playSegment(text);
        earIconPlayed = true;
    }

    const iterateComputerAudio = (e) => {
        let { currentTime } = e.target;
        let oldTextIndex = computerIndex;

        if (computerOffsets && computerOffsets.length) {
            while ((computerIndex < computerOffsets.length - 1) && ((currentTime * 1000) > (computerOffsets[computerIndex]))) {
                computerIndex++;
            }

            if ((oldTextIndex !== computerIndex) && ((computerIndex - oldTextIndex) === 1)) {
                setHighlightWordIndex(computerIndex);
            } else if ((computerIndex > oldTextIndex) && ((computerIndex - oldTextIndex) > 1)) {
                skippedIndex = computerIndex;

                setHighlightWordIndex(computerIndex - 1);
                setTimeout(() => {
                    setHighlightWordIndex(skippedIndex);
                }, 200);
            }
        }
    }

    const iteratePlayerAudio = (e) => {
        let { currentTime } = e.target;
        let oldTextIndex = textIndex;
        if (analysisOffsets && analysisOffsets.length) {
            while ((textIndex < analysisOffsets.length - 1) && ((currentTime * 1000) > (analysisOffsets[textIndex] / 10000))) {
                textIndex++;
            }
            if ((oldTextIndex !== textIndex) && ((textIndex - oldTextIndex) === 1)) {
                setHighlightWordIndex(textIndex);
            } else if ((textIndex > oldTextIndex) && ((textIndex - oldTextIndex) > 1)) {
                skippedIndex = textIndex;
                setHighlightWordIndex(textIndex - 1);
                setTimeout(() => {
                    setHighlightWordIndex(skippedIndex);
                }, 200);
            }
        }
    }

    const toggleRecording = () => {

        if (isRecording) {
            toggleAutoRecording = false;
            holdReviewIndex = reviewIndex;
            window.objMd.mediaRecorder.stop();
            setIsRecording(false);
        } else {
            earIconPlayed = false;
            if (isWindowAvailable()) {
                try {
                    window.objMd.mediaRecorder.start();
                } catch (err) {
                    var okToRefresh = window.confirm("Failed to start media recorder, Please reload the page.");
                    if (okToRefresh) {
                        window.location.reload();
                    }
                }
            };
            setIsRecording(true);
            toggleAutoRecording = false;
        }
    }

    const handleAudioError= (e) => {
            console.log('Audio error:', e);
            setAudioError(true)
    }

    let { analysis, showText, text, type, analysisIndex } = reviewData[reviewIndex];
    let savedData;
    if (reviewData[reviewIndex].type === 'RecordedMedia' || reviewData[reviewIndex].type === "Computer-Human" || reviewData[reviewIndex].type === "Player") {
        savedData = JSON.parse(savedSessionResponse.data.savedData);
        analysis = savedData[analysisIndex];
    }
    if (analysis) {
        let indexes = sessionData && JSON.parse(sessionData.indexes);
        let currentGroup = parseInt(indexes[analysisIndex]);
        let storySegmentDto = reviewStory?.storySegmentDto;
        let storySegment;
        let indexFound = false;

        if (!_.isEmpty(fullStory)) {
            fullStory.storySegmentDto.forEach(item => {
                if (item.groupNumber === currentGroup) {
                    item.text && (text += item.text + ' ');
                    if (!indexFound) {
                        currentIndex = item.section;
                        indexFound = true;
                    }
                }
            })
            storySegment = fullStory.storySegmentDto[currentIndex];
        } else {
            storySegmentDto.forEach(item => {
                if (item.groupNumber === currentGroup) {
                    item.text && (text += item.text + ' ');
                    if (!indexFound) {
                        currentIndex = item.section;
                        indexFound = true;
                    }
                }
            })
            storySegment = storySegmentDto[currentIndex];
        }
    }
    let newStoryWordList = showText ? text.split(' ') : null;
    newStoryWordList = newStoryWordList && newStoryWordList.map(item => {
        if (item.includes('.')) {
            item = item.replace(/\./, '. ');
        }
        return item;
    });
    storyWordList = newStoryWordList || storyWordList;
    currentAnalysis = analysis || currentAnalysis;

    return (
        <>
            <div className="centerText">
                <div className="innerText">
                    <div className="review_page_inbox">
                        {url.length > 0 && playUser && (
                            <div style={{ display: 'none' }}>
                                <audio
                                    id='reviewAud'
                                    controls
                                    autoPlay
                                    // onPlay={() => { computerIndex = 0; textIndex = 0; }}
                                    onEnded={handleAudioEnd}
                                    onTimeUpdate={(e) => {
                                        playHumanVoice && iteratePlayerAudio(e);
                                        playComputerVoice && iterateComputerAudio(e);
                                    }}
                                    onError={handleAudioError}
                                >
                                    <source src={url} type={"audio/mpeg"} />
                                </audio>
                            </div>
                        )}

                        {reviewData[reviewIndex] && (
                            <div className='text_box' >
                                <StoryText
                                    reviewIndex={reviewIndex}
                                    highlightWordIndex={highlightWordIndex || null}
                                    playRecording={playRecording}
                                    playComputer={playUser}
                                    storyWordList={storyWordList}
                                    analysis={currentAnalysis}
                                    settings={settings.data}
                                    playComputerVoice={playComputerVoice}
                                    paraSegments={paraSegments}
                                    paraSegmentsIndex={paraSegmentsIndex}
                                >
                                </StoryText>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {type === "Player" &&
                <div className="review_page_icons_container">
                    <Stack direction="row" spacing={{ xs: 4, sm: 4, md: 5, xl: 5 }}>
                        <Tooltip title="Hearing" arrow>
                            <IconButton
                                variant="contained"
                                className="icon_size"
                                onClick={() => { handleEarIcon(text) }}
                                disabled={isRecording}
                            >
                                <HearingIcon className={isEarIconRed ? "start" : 'hearing_icon'} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Click to record" arrow>
                            <IconButton
                                ref={recordRef}
                                variant="contained"
                                className="icon_size"
                                onClick={toggleRecording}
                                disabled={isEarIconRed}
                            >
                                <RecordVoiceOverIcon className={isRecording ? "start" : 'record_icon'} />
                            </IconButton>
                        </Tooltip>
                    </Stack>
                </div>
            }
            {
                audioError && <Dialog open={audioError}
                onClose={(e,reason)=>{
                    if(reason !== "backdropClick" && reason !== "escapeKeyDown" )
                    setAudioError(false)}
                }
                >
                    <DialogContent>
                        <Typography style={{textAlign:"center"}} variant='h6'>Looks like something went wrong while playing the audio,
                        <br/>Click on the 'ok' button to skip to the story page.</Typography>
                    </DialogContent>
                    <DialogActions>
              <Button onClick={()=>{
                localStorage.setItem(`review_done`, "true");
                history.push("/story/" + savedSessionResponse?.data?.bookId);
              }} color='primary'>
                    OK
                  </Button>
              </DialogActions>
                </Dialog>
            }
        </>
    )
}

const mapState = ({ platform: { analysis: { savedSessionResponse }, story, fullStory, auth, settings } }) => {
    return {
        auth,
        savedSessionResponse,
        story,
        settings,
        fullStory,
    }
};

export default connect(mapState)(ReviewPage);